import { defineMessages, IntlShape } from "react-intl";

enum GoalType {
  NO_GOAL,
  MIN_GOAL, // like new records
  MAX_GOAL, // like records overdue
}

const messages = defineMessages({
  [GoalType.MAX_GOAL]: {
    id: "dashboard.goalType.maxGoal",
    defaultMessage: "Maximum Amount",
    description: "Maximum Amount display name",
  },
  [GoalType.MIN_GOAL]: {
    id: "dashboard.goalType.minGoal",
    defaultMessage: "Minimum Goal",
    description: "Minimum Goal display name",
  },
});

export const getGoalTypeDisplayName = (intl: IntlShape, goalType: GoalType) =>
  goalType === GoalType.NO_GOAL ? undefined : intl.formatMessage(messages[goalType]);

export default GoalType;
